import { useState } from "react";

function useLocalStorageSelect(key, defaultValue, options = []) {
  const [selectedOption, setSelectedOption] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      if (saved) {
        const parsedValue = JSON.parse(saved);
        // Verify the saved option still exists in current options
        const validOption = options.find(
          (opt) => opt.value === parsedValue.value
        );
        return validOption || defaultValue;
      }
    } catch (error) {
      console.warn("Error loading from localStorage:", error);
    }
    return defaultValue;
  });

  const handleChange = (option) => {
    setSelectedOption(option);
    if (option) {
      localStorage.setItem(key, JSON.stringify(option));
    } else {
      localStorage.removeItem(key);
    }
  };

  return [selectedOption, handleChange];
}

export default useLocalStorageSelect;
